import { downloadCSV } from '@helpers/downloadCSV';
import { formatCentsPrice } from '@helpers/formatCentsPrice';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { AdminTransactionListItemDto } from 'app/API';

const headers = [
  'ID',
  'Created',
  'Title',
  'Charge ID',
  'Organization',
  'Organization Slug',
  'Organization ID',
  'Amount',
  'Transaction Code',
  'Type',
  'Receipt Url',
  'Associated User',
  'Associated Job',
];

export const downloadAdminTransactionsCsv = (transactions: AdminTransactionListItemDto[]) => {
  const array = transactions.map((data) => {
    return {
      id: data.id,
      created: getAmericanTime(data.createdAt),
      title: data.title,
      chargeId: data.stripeChargeId ?? data.id,
      organization: data.organization?.name ?? '',
      organizationSlug: data.organization?.slug ?? '',
      organizationId: data.organization?.id ?? '',
      amount: formatCentsPrice(data.amount ?? 0),
      code: data.codeId,
      type: data.codeId,
      receiptUrl: data.stripeReceiptUrl ?? '',
      associatedUser: data.userResponsibleEmail ?? '',
      associatedJob: data.jobId ?? '',
    };
  });
  return downloadCSV(array, headers);
};
